// Copyright 2020 Sorama B.V.

import { IWorkflowPropertyParser } from "libraries/WorkflowFramework/Interfaces/IWorkflowPropertyParser";
import { Pressure } from "units/Pressure";
import { WeightedUnit } from "units/Unit";

export class WeightedPressureUnitParser implements IWorkflowPropertyParser<WeightedUnit> {
    toWorkflowProperty(object: WeightedUnit): string {
        return object.unit;
    }

    fromWorkflowProperty(str: unknown): WeightedUnit {
        const unit = Pressure.WeightedDbUnits.find((x) => x.unit === str);
        return unit ? unit : Pressure.WeightedDbUnits[0];
    }
}
